import MainContentA11ySkipAlert from './main-content-a11y-skip-alert';

export default MainContentA11ySkipAlert;
